export function illustrationView(requirement) {
  const match = requirement?.match
  if (!match?.manifest_backed) return { available: false, message: 'No manifest-backed illustration.' }
  if (!match.image_exists) return { available: false, message: 'Manifest entry found, but the image file is missing.', metadata: match }
  return { available: true, message: 'Manifest-backed illustration available.', metadata: match }
}

